import React from "react";
import { useSelector } from "react-redux";
import { selectAuth } from "../../components/auth/auth.selector";
import CartHistoryCommon from "../../components/payment-link-system/cart-history/CartHistoryCommon";

const CartHistory = () => {
    const authData = useSelector(selectAuth);
    const userInfoData = authData.user;

    return (
       <CartHistoryCommon userInfoData={userInfoData} />
    );
}

export default CartHistory;
